import { render } from "./OurServeces.vue?vue&type=template&id=0d9d9dc3"
import script from "./OurServeces.js?vue&type=script&lang=js"
export * from "./OurServeces.js?vue&type=script&lang=js"

import "./OurServeces.vue?vue&type=style&index=0&id=0d9d9dc3&lang=css"

import exportComponent from "C:\\VueJs\\odeveloper\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__